import { api, makeApiRequest } from 'api/_init'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapCampaignsResponse } from './mappers'

const campaignDiscoveryApi = {
  // Paginated, same convention as v3's GET /events/{id}/campaigns — page/limit
  // built into the URL directly (makeApiRequest's 'get' branch doesn't
  // forward a `params` option, only headers/cancelToken/signal/timeout).
  fetchAsync: async (eventId, { page = 1, pageLimit = 50, signal } = {}) => {
    const response = await makeApiRequest(
      api,
      'get',
      `/events/${eventId}/campaigns?page=${page}&limit=${pageLimit}`,
      null,
      { signal },
    )
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapCampaignsResponse(data), status }
    }
    return { error, status }
  },
}

export default campaignDiscoveryApi
